import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

import { OrderLineType } from '@app/shared/constants';

export type RentalDirection = 'install' | 'reprise';

// Sens d'une ligne louée, lu sur le signe de sa quantité (règle de JP du 29/10 : la reprise est un −1 sur la ligne) ; les autres types n'ont pas de flèche.
export function rentalDirection(typ: OrderLineType | string | null | undefined, qty: number | string | null | undefined): RentalDirection | null {
  if (typ !== OrderLineType.RENTAL) return null;
  return Number(qty) < 0 ? 'reprise' : 'install';
}

// Flèche en tête de ligne : verte vers la droite pour une installation, rouge vers la gauche pour une reprise.
@Component({
  selector: 'app-rental-direction',
  templateUrl: './rental-direction.component.html',
  styleUrls: ['./rental-direction.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatIconModule],
})
export class RentalDirectionComponent {
  @Input() typ: OrderLineType | string | null | undefined = null;
  @Input() qty: number | string | null | undefined = null;	// quantité sur le BL (ou de la ligne) : négative = reprise

  get dir(): RentalDirection | null {
    return rentalDirection(this.typ, this.qty);
  }
}
